
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.054 25.732c1.465 0 2.841-.28 4.13-.84a10.935 10.935 0 005.713-5.713 10.27 10.27 0 00.835-4.125c0-1.465-.278-2.84-.834-4.126a10.898 10.898 0 00-2.313-3.405 10.879 10.879 0 00-3.411-2.313 10.308 10.308 0 00-4.131-.835c-1.45 0-2.82.278-4.11.835a10.879 10.879 0 00-3.41 2.313 10.897 10.897 0 00-2.313 3.405 10.269 10.269 0 00-.835 4.126c0 1.465.28 2.84.84 4.125a10.954 10.954 0 002.313 3.4 10.935 10.935 0 003.406 2.313c1.289.56 2.662.84 4.12.84zm-.077-14.392c-.41 0-.755-.14-1.033-.423a1.408 1.408 0 01-.417-1.027c0-.41.139-.756.417-1.038a1.393 1.393 0 011.033-.423c.395 0 .734.141 1.016.423.282.282.423.628.423 1.038 0 .403-.141.745-.423 1.027-.282.282-.62.423-1.016.423zm2.549 9.613h-4.373a.832.832 0 01-.588-.23.763.763 0 01-.247-.583c0-.22.082-.41.247-.57a.812.812 0 01.588-.243h1.296V14.67h-1.11a.838.838 0 01-.592-.225.766.766 0 01-.242-.588c0-.22.08-.408.242-.566a.816.816 0 01.593-.236h2.043c.293 0 .515.095.665.286.15.19.225.44.225.747v5.24h1.253c.234 0 .432.081.593.242a.781.781 0 01.242.571c0 .235-.081.429-.242.583a.827.827 0 01-.593.23z","fill":"#E53935"}})])
          )
        }
      }
    